module.exports = __webpack_public_path__ + "fonts/AdelleSAGE.7391e57e.ttf";